import { render, staticRenderFns } from "./BackOfficeLayout.vue?vue&type=template&id=44b3bf49&scoped=true"
import script from "./BackOfficeLayout.vue?vue&type=script&lang=js"
export * from "./BackOfficeLayout.vue?vue&type=script&lang=js"
import style0 from "@/core/Assets/scss/typography.scss?vue&type=style&index=0&prod&lang=scss&external"
import style1 from "./BackOfficeLayout.vue?vue&type=style&index=1&id=44b3bf49&prod&lang=scss&scoped=true"
import style2 from "./BackOfficeLayout.vue?vue&type=style&index=2&id=44b3bf49&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44b3bf49",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VMain } from 'vuetify/lib/components/VMain';
import { VOverlay } from 'vuetify/lib/components/VOverlay';
installComponents(component, {VMain,VOverlay})
